import script from "./SelectedBonusesDisplay.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectedBonusesDisplay.vue?vue&type=script&setup=true&lang=ts"

import "./SelectedBonusesDisplay.vue?vue&type=style&index=0&id=49728775&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49728775"]])

export default __exports__